import BaseDrawer from '@/components/ui/BaseDrawer';
import BaseButton from '@/components/ui/BaseButton';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';

type ConfirmBottomDrawerProps = {
    open: boolean;
    title?: string;
    children: ReactNode;
    confirmText: string;
    cancelText: string;
    onConfirm: () => void | Promise<void>;
    onClose: () => void;
    onExited?: () => void;
    onEnter?: () => void;
    showCloseButton?: boolean;
    confirmDisabled?: boolean;
    cancelDisabled?: boolean;
    confirmLoading?: boolean;
    disableReason?: string;
};

const BaseConfirmDrawer = ({
    open,
    title,
    children,
    confirmText,
    cancelText,
    onConfirm,
    onClose,
    onExited,
    onEnter,
    confirmDisabled = false,
    cancelDisabled = false,
    confirmLoading = false,
    disableReason,
}: ConfirmBottomDrawerProps) => {
    const isConfirmDisabled = confirmDisabled || confirmLoading;

    return (
        <BaseDrawer
            open={open}
            title={title}
            onClose={onClose}
            onExited={onExited}
            onEnter={onEnter}
            footer={
                <Stack spacing={1}>
                    {disableReason && isConfirmDisabled && (
                        <span
                            style={{
                                fontSize: 12,
                                color: '#DC2626',
                                textAlign: 'center',
                            }}
                        >
                            {disableReason}
                        </span>
                    )}

                    <Stack spacing={1} direction="row" justifyContent="space-between">
                        <BaseButton
                            fullWidth
                            variant="outlined"
                            onClick={onClose}
                            disabled={cancelDisabled || confirmLoading}
                        >
                            {cancelText}
                        </BaseButton>

                        <BaseButton
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={onConfirm}
                            disabled={isConfirmDisabled}
                        >
                            {confirmLoading ? 'Loading...' : confirmText}
                        </BaseButton>
                    </Stack>
                </Stack>
            }
        >
            {children}
        </BaseDrawer>
    );
};

export default BaseConfirmDrawer;
